import { Loader2 } from 'lucide-react';

// iOS-style centered confirmation alert. Used for destructive actions
// (menu item delete, account delete, sign out) across Menu/Profile.
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  destructive = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-8">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={busy ? undefined : onCancel}
      />
      <div className="relative w-full max-w-xs bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="px-5 pt-5 pb-4 text-center">
          <h3 className="text-base font-bold text-gray-900">{title}</h3>
          {message && (
            <p className="mt-1.5 text-sm text-gray-500 leading-snug">{message}</p>
          )}
        </div>
        <div className="flex border-t border-gray-100 divide-x divide-gray-100">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="flex-1 py-3 text-sm font-semibold text-gray-600 active:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`flex-1 py-3 text-sm font-bold flex items-center justify-center gap-2 active:bg-gray-50 disabled:opacity-50 ${
              destructive ? 'text-red-500' : 'text-[#FF6B35]'
            }`}
          >
            {busy && <Loader2 size={15} className="animate-spin" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
